import { MainContentWrapper } from '@repo/ui/components/MainContentWrapper/MainContentWrapper';
import { DropdownCoordinatorProvider } from '@repo/ui/hooks/use-coordinated-dropdown';

import { AdminHeader } from '../AdminHeader';
import { AdminSidebar } from '../AdminSidebar';

import './AdminDashboardWrapper.scss';

interface AdminDashboardWrapperProps {
  children: React.ReactNode;
}

export function AdminDashboardWrapper({ children }: AdminDashboardWrapperProps) {
  return (
    <DropdownCoordinatorProvider>
      <AdminHeader />
      <div className="AdminDashboardWrapper">
        <AdminSidebar />
        <MainContentWrapper>{children}</MainContentWrapper>
      </div>
    </DropdownCoordinatorProvider>
  );
}
